import { toNumber } from 'lodash'
import capitalize from '@/utils/capitalize'
import {
  getCampaignDeeplink,
  getListingTypeText,
  streetName,
  formatListingAddress,
  unitHidden,
  getFurnished,
  renderAvailability,
  getBedrooms,
  formatFee
} from './share-functions.js'

const getBathrooms = listing => {
  if (listing.unit_type_scope_txt_id === 'entire')
    return `<li>${parseFloat(listing.count_all_bathrooms)} bathroom</li>`
  const fullBath =
    toNumber(listing.count_full_shared_bathrooms) > 0
      ? `<li>${parseFloat(listing.count_full_bathrooms)} private bathroom</li>`
      : ''
  const privateBath =
    toNumber(listing.count_full_shared_bathrooms) > 0
      ? `<li>${parseFloat(listing.count_full_shared_bathrooms)} shared bathroom</li>`
      : ''
  return `${fullBath}${privateBath}`
}

const getDenFlex = listing =>
  toNumber(listing.count_dens) > 0 ? `<li>${listing.count_dens} den/flex</li>` : ''

const formatAmenities = (features, customFeatures, unitType) => {
  const combinedFeatures = [...features, ...customFeatures]
  const featuresArray = combinedFeatures.map(item => {
    let featureText = [item.name]
    if (unitType !== 'entire') {
      featureText.push(`(${item.type})`)
    }
    return `<li>${featureText.join(' ')}</li>`
  })
  return featuresArray.join('')
}

const CopyListingCraigslist = async (listing, areaMeasurementUnit) => {
  const listingUrl = await getCampaignDeeplink('facebook', listing.listing_id)
  return `
    <html>
      <body>
        <br/>
        <h2>**Message or Apply Now at <u>${listingUrl}</u>**</h2>
        <h3>${getListingTypeText(listing.unit_type_txt_id, listing.unit_type_scope_txt_id)} ${
    !unitHidden(listing) ? `Unit ${listing.unit_number} ` : ''
  }at ${formatListingAddress(listing)}</h3>
        <font size="3"><b>Unit Details:</b></font>
        <ul>
          <li>${getBedrooms(listing, areaMeasurementUnit)}</li>
          ${getBathrooms(listing)}
          ${getDenFlex(listing)}
          ${
            listing.unit_type_scope_txt_id === 'single' ? '' : `<li>Size: ${listing.size} sqft</li>`
          }
          <li>${getFurnished(listing)}</li>
        </ul><br/>
        <font size="3"><b>Rental Terms and Conditions:</b></font>
        <ul>
          ${listing.max_occupancy > 0 ? `<li>Max. occupancy: ${listing.max_occupancy}</li>` : ''}
          <li>Pets: ${listing.allow_pets ? 'Yes' : 'No'}</li>
          <li>Smoking: ${listing.allow_smoking ? 'Yes' : 'No'}</li>
          <li>
            Lease Type: ${capitalize(listing.lease_type).replace(/_/g, ' ')}
          </li>
          <li>Available date: ${renderAvailability(listing)}</li>
        </ul><br/>
        ${
          !!listing?.description
            ? `<font size="3"><b>About This Property:</b></font><p>${listing.description.replace(
                /(?:\r\n|\r|\n)/g,
                '<br>'
              )}</p><br/>`
            : ``
        }
        <br/>
        <font size="3"><b>Amenities:</b></font>
        <ul>
        ${
          formatFee(listing.parking, 'Parking')
            ? `<li>${formatFee(listing.parking, 'Parking')}</li>`
            : ''
        }
        ${
          formatFee(listing.storage, 'Storage')
            ? `<li>${formatFee(listing.storage, 'Storage')}</li>`
            : ''
        }
        ${formatAmenities(
          listing.unit_features,
          listing.custom_features,
          listing.unit_type_scope_txt_id
        )}
        ${formatAmenities(
          listing.listing_utilities,
          listing.custom_utilities,
          listing.unit_type_scope_txt_id
        )}
        </ul><br/>
        <font size="3"><b>About the Building:</b></font>
        <ul>
          <li>Address: ${streetName(listing)}</li>
          <li>Neighborhood: ${listing.building.neighborhood || listing.building.city}</li>
        </ul><br/>
      </body>
    </html>
  `.replace(/[\r\n]/gm, '')
}

export default CopyListingCraigslist
